export enum SelectedScriptLanguage
{
  GDScript,
  CSharp,
  Editor
}

export enum MemberDefinitionOrder
{
  NameType,
  TypeName
}

export enum VisibleState
{
  Invisible,
  Visible
}

export enum ClassFilter
{
  All,
  Editor,
  _2D,
  _3D,
  Control,
  Node,
  Resource,
  Audio,
  Action,
  Logic,
  Sensor,
  UI,
  Procedural,
  Camera,
  Timeline,
  Networking,
  Rendering,
  Shaders,
  Locales,
  Math,
  Structures,
  Text,
  Animation,
  CompositorFX
}

export class DocSearchSettings
{
  t = SelectedScriptLanguage.GDScript;
  c = VisibleState.Visible;
  cf = ClassFilter.Editor;
  o = VisibleState.Visible;
  md = MemberDefinitionOrder.NameType; 
  h = false;
  exp = false;
  gd = VisibleState.Visible;
  rj = VisibleState.Invisible; 
  dev = VisibleState.Invisible;
}